export default __webpack_public_path__ + "media/Others.a4876a37.svg";